// extracted by mini-css-extract-plugin
module.exports = {"label":"MapFilterToggle_label__2zmgH"};